export const VisionIcon = () => (
  <svg viewBox="0 0 24 24" className="card-icon">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12Z"
    />
    <circle
      cx="12"
      cy="12"
      r="3"
      fill="currentColor"
    />
  </svg>
);


export const MissionIcon = () => (
  <svg viewBox="0 0 24 24" className="card-icon">
    <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="2" />
    <circle cx="12" cy="12" r="5" fill="none" stroke="currentColor" strokeWidth="2" />
    <circle cx="12" cy="12" r="1.8" fill="currentColor" />
  </svg>
);



export const ValuesIcon = () => (
  <svg viewBox="0 0 24 24" className="card-icon">
    <path
      fill="currentColor"
      d="M12 2 3 9l9 13 9-13-9-7Zm0 3.4 4.8 3.6L12 18 7.2 9 12 5.4Z"
    />
  </svg>
);

